export default __webpack_public_path__ + "static/media/320x180.a8915694.jpg";